import { StructError, create } from 'superstruct';
import { HTTPError } from 'ky';
import { Payload } from './payload';
export { ItemsAddedToCart } from './response';
export const makeAddItemsToCart = function(agent) {
    return async function addItemsToCart(rawPayload) {
        try {
            const payload = create(rawPayload, Payload);
            return await agent.post('/cart/add.js', {
                json: payload
            }).json();
        } catch (err) {
            if (err instanceof StructError) {
                console.error(err, {
                    payload: rawPayload
                });
                throw new Error('Internal validation error');
            }
            if (err instanceof HTTPError) {
                const details = await err.response.json();
                console.warn(details, {
                    payload: rawPayload
                });
                throw new Error(details.description || details.message || 'Cart Error');
            }
            throw new Error('Internal error');
        }
    };
};
